import { Organization, User } from "types";

export const fetchPracticesAction = (organizations: Organization[]) => {
  return {
    type: "FETCH_PRACTICES",
    payload: organizations,
  };
};

export const fetchPracticeUsersAction = (practiceUsers: User[]) => {
  return {
    type: "FETCH_PRACTICE_USERS",
    payload: practiceUsers,
  };
};

export const addPracticeAction = (organization: Organization) => {
  return {
    type: "ADD_PRACTICE",
    payload: organization,
  };
};

export const createPracticeAction = (organization: Organization) => {
  return {
    type: "CREATE_PRACTICE",
    payload: organization,
  };
};

export const updatePracticeAction = (organization: Organization) => {
  return {
    type: "UPDATE_PRACTICE",
    payload: organization,
  };
};

export const deletePracticeAction = (organizationId: string) => {
  return {
    type: "DELETE_PRACTICE",
    payload: organizationId,
  };
};
